import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const GrantSkeleton = () => (
    <div style={{width: 364}}>
        <Group direction="v" alignItems="start">
            <FormItemSkeleton labelWidth={110}>
                <SkeletonItem width={300} height={18}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={110}>
                <SkeletonItem width={66} height={18}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={110}>
                <SkeletonItem width={200} height={18}/>
            </FormItemSkeleton>
            <FormItemSkeleton labelWidth={110}>
                <SkeletonItem width={300} height={18}/>
            </FormItemSkeleton>
        </Group>
    </div>
);
